import { CommonProp } from '@acin/ui-core';
import React from 'react';
import { useObligationRisks } from '../hooks/useObligationRisks';
import * as SC from './RisksList.styled';

export interface RisksListProps extends CommonProp {
  className?: string;
  selectedObligationId?: string;
}

export const RisksList: React.FC<RisksListProps> = ({ className, selectedObligationId }) => {
  const { risks, loading, error } = useObligationRisks(selectedObligationId);

  // Empty state - no obligation selected
  if (!selectedObligationId) {
    return (
      <SC.RisksList className={className}>
        <SC.EmptyState>Select an obligation to view its risks</SC.EmptyState>
      </SC.RisksList>
    );
  }

  // Loading state
  if (loading) {
    return (
      <SC.RisksList className={className}>
        <SC.EmptyState>Loading risks...</SC.EmptyState>
      </SC.RisksList>
    );
  }

  // Error state
  if (error) {
    return (
      <SC.RisksList className={className}>
        <SC.EmptyState>Error loading risks</SC.EmptyState>
      </SC.RisksList>
    );
  }

  // No risks found
  if (risks.length === 0) {
    return (
      <SC.RisksList className={className}>
        <SC.EmptyState>No risks found for this obligation</SC.EmptyState>
      </SC.RisksList>
    );
  }

  // Render risks list
  return (
    <SC.RisksList className={className}>
      <SC.List>
        {risks.map((risk) => (
          <SC.Item key={risk.id}>
            <SC.ItemName>{risk.name}</SC.ItemName>
            {risk.approvalStatus && <SC.ItemStatus>{risk.approvalStatus}</SC.ItemStatus>}
          </SC.Item>
        ))}
      </SC.List>
    </SC.RisksList>
  );
};
